import { MenuBody, MenuHeader } from './components';

import { useMenuPage } from './hooks';

import makeClasses from './MenuPage.style';

export function MenuPage() {
  const {
    store,
    stores,
    isLoadingCatalog,
    catalog,
    outOfStock,
    searchQuery,
    changeStore,
    refreshCatalog,
    onSearch,
  } = useMenuPage();

  const _classes = makeClasses();

  return (
    <div aria-label='menu-page' className={_classes.menuPage}>
      <MenuHeader
        store={store}
        stores={stores}
        searchQuery={searchQuery}
        onSearch={onSearch}
        onChangeStore={changeStore}
        refreshCatalog={refreshCatalog}
      />
      <MenuBody
        loading={isLoadingCatalog}
        storeId={store.id}
        searchQuery={searchQuery}
        catalog={catalog}
        outOfStock={outOfStock}
        refreshCatalog={refreshCatalog}
      />
    </div>
  );
}
